import type {ChangeEventHandler, MouseEventHandler} from 'react';
import React from 'react';
import './toggle-switch.scss';

interface ToggleSwitchProps {
  id: string;
  isChecked?: boolean;
  handleToggle?: MouseEventHandler;
  onToggleChange?: ChangeEventHandler;
  className?: string;
}

export function ToggleSwitch({
  isChecked = false,
  handleToggle = $.noop,
  onToggleChange = $.noop,
  className = '',

  ...props
}: ToggleSwitchProps) {
  return (
    <>
      <input type="checkbox" className="tgl" id={props.id} onChange={onToggleChange} onClick={handleToggle} checked={isChecked} />
      <label htmlFor={props.id} className={`tgl-btn ${className}`} />
    </>
  );
}
